import React, { Component } from 'react';

import { PackageTypes } from 'src/Common/constants';
import {
  Back,
  Card,
  CardFooter,
  CardHeader,
  ContractTermOptions,
  IncludedServiceComponent,
} from 'src/Components/Common';

import GreyPromotionIcon from 'src/Components/Common/Svg/GreyPromotionIcon';
import PurplePromotionIcon from 'src/Components/Common/Svg/PurplePromotionIcon';
import VerticalBar from 'src/Components/Common/Svg/VerticalBar';
import DataIcon from 'src/Components/Common/Svg/DataIcon';
import DataIconMobile from 'src/Components/Common/Svg/DataIconMobile';
import DownloadDataIcon from 'src/Components/Common/Svg/DownloadDataIcon';
import UploadDataIcon from 'src/Components/Common/Svg/UploadDataIcon';
import TickGreen from 'src/Components/Common/Svg/TickGreen';

import { SalesContext } from 'src/Context/SalesContext';

import { getAdditionalServices } from 'src/Services/Services';

import {
  getDrivePackageImageURL,
  addBeforeloadEvent,
  removeBeforeloadEvent,
  getSelectedProductsArrays
} from 'src/Utility/utility';

import {
  tagOnFibrePlanDetailsContractDuration,
  tagOnFibrePlanDetailsContinueToCheckout,
  tagOnFibrePlanDetails
} from 'src/Tagging/SalesTagging';

import {
  AdditionalServices,
  FibreAddress,
  VodacomPreBanner,
} from './components';

import './PlanDetails.css';

class PlanDetails extends Component {
  static contextType = SalesContext;

  state = {
    packageProviderImg: '',
    selectedPackage: {},
    additionalServices: null,
    selectedTerm: '',
    totalMonthlyCost: null,
    totalOnceOffCost: null,
    isLteToggle: false,
    currentToggleState: false,
    description: null,
    promotion: '',
    offeringID: '',
    servicePlans: [],
    parameterId: null,
    responseStatus: null,
    vasCategory: '',
    displayName: '',
    priceDescription: null,
    lteImageUrl: '',
    voiceLineImageUrl: '',
    superWifiImageUrl: '',
    genericDiscount: {},
    handleError: null,
    taggingPlanName: '',
    selectedDiscountTerm: ''
  };

  handleInputChange = (value) => {
    let addVas = this.context.additionalVas;
    if (addVas) {
      for (let index = 0; index < addVas.length; index++) {
        if (addVas[index].category === 'superWifi') {
          addVas.splice(index, 1);
        }
      }
    }

    this.context.setAdditionalVas(addVas);
    this.context.setSelectedAdditionalServices({ key: 'superWifi', value: false });
    this.setState({ selectedTerm: value });

    // Set the selected contract term to context

    this.context.contractTerm && this.context.contractTerm.forEach(term => {
      if (term.offeringID === value) {

        this.setState({ selectedDiscountTerm: term });
        this.context.setSelectedContractTerm(term);
      }
    });
    tagOnFibrePlanDetailsContractDuration();
  }

  handleToggle = () => {
    this.setState(prevState => ({
      isLteToggle: !prevState.isLteToggle,
    }), () => this.handleCurrentToggleState(this.state.isLteToggle));
  }

  handleCurrentToggleState = (isLteToggleValue) => {
    this.setState({
      currentToggleState: isLteToggleValue
    })
  }

  handleUpdateAddress = (addressLine) => {
    const newAddress = { ...this.context.installationAddress, [addressLine.key]: addressLine.value };
    this.context.setInstallationAddress(newAddress);
  }

  initialiseState = async () => {
    const { selectedPackage, additionalServices } = this.context;
    if (!selectedPackage) {
      return;
    }

    const packageProviderImg = getDrivePackageImageURL(selectedPackage.provider);

    if (!this.context.additionalServices) {
      try {
        const additionServices = await getAdditionalServices();
        additionServices.serviceCategories.map(el => {
          if (el.vasCategory === 'voip') {
            el.vasCategory = 'voiceLine';
          }
          this.context.setSelectedAdditionalServices({ key: el.vasCategory, value: false });
        })
        this.context.setAdditionalServices(additionServices);
      } catch {
        console.log('Failed to fetch additional services');
      }
    }


    this.setState({
      packageProviderImg,
      selectedPackage,
      additionalServices
    });
  }

  OnProductSelect = () => {
    let totalCost = 0;
    totalCost += parseInt(this.context.selectedPackage.productPrice.value);
    this.context.setMonthlyCost(totalCost);

    this.setState({
      totalMonthlyCost: totalCost
    })
  }

  componentWillUnmount = () => {
    removeBeforeloadEvent();
  }

  componentDidMount = () => {

    addBeforeloadEvent();
    this.initialiseState();

    if (this.context.selectedPackage)
      tagOnFibrePlanDetails(this.context.selectedPackage.provider + ' - ' + this.context.selectedPackage.description, 1, this.context.selectedPackage.productPrice.value, !!this.context.selectedPackage.isRecommended);

    if (this.context.selectedContractTerm && this.state.selectedTerm !== this.context.selectedContractTerm.offeringID) {
      this.setState({
        selectedTerm: this.context.selectedContractTerm.offeringID
      });
    }

    this.OnProductSelect();

    if (this.context.selectedPackageType === PackageTypes.VodacomOneDeals
      || this.context.selectedPackageType === PackageTypes.PremiumFibreDeals
    ) {
      if (this.context.selectedPackage) {
        this.context.setSelectedContractTerm({
          'contractTerm': '24 Months',
          'inclusions': this.context.selectedPackage.contractTerms[0].inclusions,
          'offeringID': this.context.selectedPackage.contractTerms[0].offeringID,
          'onPromotion': this.context.selectedPackage.onPromotion
        })
      }
    }
  }

  submitFormClickHandler = () => {
    const { taggingIdArray, taggingQtyArray, taggingPriceArray } = getSelectedProductsArrays(
      this.context.selectedPackage,
      this.context.selectedAdditionalServices,
      this.context.additionalServices
    );

    tagOnFibrePlanDetailsContinueToCheckout(taggingIdArray, taggingQtyArray, taggingPriceArray);
  }

  render() {

    const {
      packageProviderImg,
      selectedPackage,
      vasCategory,
      description,
      displayName,
      imageUrl,
      promotion,
      offeringID,
      servicePlans,
      parameterId,
      responseStatus,
      priceDescription,
      voiceLineImageUrl,
      superWifiImageUrl,
      lteImageUrl,
      currentToggleState,
      isLteToggle,
      taggingPlanName,
      selectedDiscountTerm
    } = this.state;

    let contractTerms = [];
    let packageInclusions = [];

    if (this.context.contractTerm) {

      contractTerms = this.context.contractTerm && this.context.contractTerm.map(term => {

        if (term.offeringID === this.state.selectedTerm) {
          packageInclusions = this.context.selectedContractTerm.inclusions;
        }

        return {
          label: term.duration,
          value: term.offeringID,
          discountTerm: term.discountTerm,
          discountAmount: term.discountAmount,
          price: this.context.selectedPackage.productPrice.value
        };
      });
    }

    contractTerms = contractTerms.sort((e, pr) => pr.label.length - e.label.length);
    contractTerms = contractTerms.sort((e, pr) => parseInt(e.label) - parseInt(pr.label));
    contractTerms = contractTerms.reverse();

    if (this.context.selectedPackageType === PackageTypes.StandaloneFibreDeals
      && !this.context.selectedContractTerm && contractTerms
    ) {
      this.handleInputChange(contractTerms[0].value)
    }

    let discountMonthValue = selectedDiscountTerm && selectedDiscountTerm.discountTerm?.split(' ');

    let discount = parseFloat(this.context.selectedPackage.productPrice.value) - parseFloat(selectedDiscountTerm.discountAmount);
    let discountMonths = discountMonthValue[0];
    let price = discount === 0 ? 'FREE' : `Only pay R${discount}`;
    let duration = discountMonths === '1' ? 'for the first month' : `for the first ${discountMonths} months`;

    let discountString = `${price} ${duration}`;

    const planInclusions = (
      <div className='plan-details-inclusions-card'>
        <div className='plan-deatils-inclusions-list'>
          {packageInclusions && packageInclusions.map((inclusion = '', index) => {

            let planInclusion = inclusion;
            let prefix = null;

            if (inclusion.toLowerCase().includes('free')) {

              planInclusion = inclusion.replace(/free/i, '');
              prefix = 'FREE';
            }

            return (
              <div key={index} className="plan-deatils-inclusions-item">
                {index > 0 &&
                  <div className='plan-deatils-inclusions-verticalBar'> <VerticalBar /> </div>
                }
                <span className='plan-details-inclusions-listItem'>
                  <div className='plan-details-inclusions-tick'><TickGreen /></div>
                  {prefix} {planInclusion}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );

    return (

      <div>
        <div className='plan-details-page-wrapper'>
          <h1 className='plan-details-heading'>
            Fibre Plan details
          </h1>

          {!selectedPackage
            ? null
            : <div className='plan-details-summary-wrapper'>
              <Card className='plan-details-summery-card plan-deatils-summery-card-mobile' automationidattr={'PlanDetails'}>
                <CardHeader className="plan-deatils-summary-card-web">
                  <div className='plan-details-summary-row-1'>
                    <div className='plan-details-summary-data'>

                      {(!!selectedPackage?.onDiscount || !!selectedPackage?.onPromotion)

                        ? <div className='plan-details-summary-discount-tag'>On promotion</div>
                        : null
                      }

                      <span className='plan-details-package-summary-data-item' >{selectedPackage.dataCap} fibre</span>
                    </div>
                    <div className='plan-details-summary-data-price'>
                      <span className='plan-details-package-price'>
                        {`R${this.context.selectedPackage.productPrice.value}

                          ${parseInt(this.context.selectedContractTerm?.duration)
                            ? 'x ' + parseInt(this.context.selectedContractTerm?.duration) + ' months'
                            : 'PM'}`
                        }
                      </span>
                      {selectedDiscountTerm && selectedDiscountTerm.discountTerm &&

                        <p className='generic-discount-container'>
                          <GreyPromotionIcon
                            marginRight='7px'
                          />
                          <span className='discount-heading'> Promotion:</span>
                          <span className='discount-text'>
                            {discountString}
                          </span>
                        </p>
                      }

                    </div>
                  </div>
                  <div className='plan-details-summary-row-2'>
                    <div className='plan-details-summary-provider'>
                      <span className='plan-details-package-summary-title'>Infrastructure provider</span>
                      <div className='plan-details-package-provider-logo'>
                        <img
                          className='plan-details-package-provider-logo-img'
                          src={packageProviderImg}
                          alt='Package Provider'
                        />
                      </div>
                    </div>
                    <div className='plan-details-summary-provider-details'>
                      <span className='plan-details-package-summary-title'>Plan:</span>
                      <span className='plan-details-package-summary-items'>
                        <DataIcon /> &nbsp; {selectedPackage.dataCap}
                      </span>
                      <span className={'plan-details-package-summary-items'}>
                        <DownloadDataIcon /> &nbsp; {selectedPackage.download} download speed
                      </span>
                      <span className={'plan-details-package-summary-items'}>
                        <UploadDataIcon /> &nbsp; {selectedPackage.upload} upload speed
                      </span>
                    </div>
                  </div>
                </CardHeader>
                {/* For mobile screen*/}
                <CardHeader automationidattr={'PlanDetails'} className="plan-deatils-summary-card-mobile">
                  <div className='plan-details-summary-discount-tag-wrapper'>
                    {(!!selectedPackage?.onDiscount || !!selectedPackage?.onPromotion)


                      ? <div className='plan-details-summary-discount-tag'>On promotion</div>
                      : null
                    }
                  </div>
                  <div className='plan-details-summary-row-1'>
                    <div className='plan-details-package-provider-logo'>
                      <img
                        src={packageProviderImg}
                        className='plan-details-package-provider-logo-img'
                        alt='Package Provider'
                      />
                    </div>
                    <span className='plan-details-package-summary-items'>
                      {selectedPackage.dataCap}
                    </span>
                    <div className='plan-details-summary-package-details'>
                      <div>
                        <div className='plan-details-summary-package-speed-details'>
                          {parseInt(selectedPackage.download) || null}
                        </div>
                        <div className='plan-details-summary-package-speed-unit'>
                          Mbps
                        </div>
                      </div>
                      <div>
                        <div><DataIconMobile /></div>
                      </div>
                      <div>
                        <div className='plan-details-summary-package-speed-details'>
                          {parseInt(selectedPackage.upload) || null}
                        </div>
                        <div className='plan-details-summary-package-speed-unit'>
                          Mbps
                        </div>
                      </div>
                    </div>
                    {selectedDiscountTerm && selectedDiscountTerm.discountTerm &&

                      <p className='generic-discount-container'>
                        <PurplePromotionIcon />
                        <span className='discount-text'>
                          {discountString}
                        </span>
                      </p>
                    }
                  </div>
                  <div className='plan-details-summary-row-2'>
                    <span className='plan-details-package-price'>
                      {`R${this.context.selectedPackage.productPrice.value} 
                      ${parseInt(this.context.selectedContractTerm?.duration) ? 'x ' +
                          parseInt(this.context.selectedContractTerm?.duration) + ' months' : 'PM'}`}
                    </span>
                  </div>
                </CardHeader>
              </Card>
              {this.context.selectedPackageType === PackageTypes.VodacomOneDeals && this.context.selectedPackage.contractTerms[0].inclusions?.length > 0
                ? <div className="device-component">
                  <IncludedServiceComponent
                    inclusionsList={this.context.selectedPackage.contractTerms[0].inclusions}
                    bgcolor="#F4F4F4"
                    isDevice={true}
                  />
                </div>
                : this.context.selectedPackageType === PackageTypes.StandaloneFibreDeals
                  ? <React.Fragment>
                    <CardFooter className='plan-details-footer' automationidattr={'PlanDetails'}>
                      <p className={'footer-title ct-font-size'}>
                        {'Choose the duration & price:'}
                      </p>
                      <ContractTermOptions
                        name='payment-term'
                        options={contractTerms || []}
                        // inline
                        onChange={this.handleInputChange}
                        selectedOption={this.state.selectedTerm}
                        totalPrice={this.context.selectedPackage.productPrice.value}
                        automationidattr={'PlanDetails'}
                      />
                    </CardFooter>
                    {Array.isArray(packageInclusions) && packageInclusions.length !== 0 ? planInclusions : null}
                  </React.Fragment>
                  : null
              }
            </div>
          }

          {this.context.selectedPackageType === PackageTypes.PremiumFibreDeals && this.context.selectedPackage.contractTerms[0].inclusions.length > 0
            ? <VodacomPreBanner inclusions={this.context.selectedPackage.contractTerms[0].inclusions} />
            : null
          }

          {this.context.selectedPackageType !== PackageTypes.PremiumFibreDeals
            ? <AdditionalServices
              updateTotalCost={() => this.OnProductSelect()}
              handleToggle={() => this.handleToggle(isLteToggle)}
              currentToggleState={currentToggleState}
              vasCategory={vasCategory}
              description={description}
              displayName={displayName}
              imageUrl={imageUrl}
              promotion={promotion}
              offerId={offeringID}
              servicePlans={servicePlans}
              parameterId={parameterId}
              responseStatus={responseStatus}
              priceDescription={priceDescription}
              superWifiImageUrl={superWifiImageUrl}
              lteImageUrl={lteImageUrl}
              voiceLineImageUrl={voiceLineImageUrl}
              taggingPlanName={taggingPlanName}
            />
            : null
          }

          <FibreAddress
            address={this.context.installationAddress}
            onUpdateAddress={this.handleUpdateAddress}
          />
        </div>

        <div className="plan-details-back-bar">
          <Back
            page="plan details"
            submitClick={this.submitFormClickHandler}
            buttonName="Checkout"
            nextUrl={this.context.leadAdditionalServices?.length >= 1 ? '/cloud/fibre/sales/contactInformation' : '/cloud/fibre/sales/deliveryAddress'}
            enabledButton={
              Boolean(
                this.state.selectedTerm
                || this.context.selectedPackageType === PackageTypes.VodacomOneDeals
                || this.context.selectedPackageType === PackageTypes.PremiumFibreDeals
              )
            }
            automationidattr={'FibreAddress'}
            backUrl="/cloud/fibre/sales/choosePlan"
          />
        </div>
      </div>
    )
  }
}

export default PlanDetails;
